module.exports = __webpack_public_path__ + "img/favorite-filled.56d3905a.svg";